import { Button, Layout, PageHeader, Table } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { apiClient, apiErrorMessage } from '../../utils';
import { ReloadOutlined } from '@ant-design/icons';

export function TaskPerformancesReport() {
  const { Content } = Layout;
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [taskPerformances, setTaskPerformances] = useState<any[]>();

  const onBackClick = () => {
    history.goBack();
  };

  const loadTaskPerformances = useCallback(() => {
    setLoading(true);
    apiClient
      .get(`reports/task-performances`)
      .then((response: any) => {
        const responseData = response.data as any[];
        setTaskPerformances(responseData);
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    loadTaskPerformances();
  }, [loadTaskPerformances]);

  const onRefreshClick = () => {
    loadTaskPerformances();
  };

  const tableColumns = [
    {
      title: 'Veri seti adı',
      dataIndex: ['gridName'],
      key: 'gridName',
    },
    {
      title: 'Veri elemanı adı',
      dataIndex: ['fieldName'],
      key: 'fieldName',
    },
    {
      title: 'Görev sayısı',
      dataIndex: ['taskCount'],
      key: 'taskCount',
    },
    {
      title: 'Ortalama tamamlama süresi (dakika)',
      dataIndex: ['averageCompletionDuration'],
      key: 'averageCompletionDuration',
    },
    {
      title: 'Ortalama beklenen süre - tamamlanma süresi farkı (dakika)',
      dataIndex: ['averageDueDateDifference'],
      key: 'averageDueDateDifference',
    }
  ];

  return (
    <>
      <PageHeader
        title="Görev tamamlama performansı"
        onBack={onBackClick}
        extra={[
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} dataSource={taskPerformances} loading={loading} scroll={{ x: '100%' }} pagination={false} />
      </Content>
    </>
  );
}
